import { render, staticRenderFns } from "./noDataSlot.vue?vue&type=template&id=c4981f1a&scoped=true"
import script from "./noDataSlot.vue?vue&type=script&lang=js"
export * from "./noDataSlot.vue?vue&type=script&lang=js"
import style0 from "./noDataSlot.vue?vue&type=style&index=0&id=c4981f1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4981f1a",
  null
  
)

export default component.exports